import React, { useEffect, useState } from 'react';
import { CustomersList } from './CustomersList';
import { CustomerProfile } from './CustomerProfile';
import { SearchIcon, FilterIcon, UserPlusIcon, UsersIcon } from 'lucide-react';
// Mock customer data
const mockCustomers = [{
  id: 1,
  firstName: 'Robert',
  lastName: 'Chen',
  email: 'robert.chen@example.com',
  phone: '+1 (555) 123-4567',
  address: '123 Main St, San Francisco, CA',
  status: 'active',
  type: 'repeat',
  lastContact: '2023-06-01',
  upcomingTrip: 'Bali Retreat - July 15, 2023',
  notes: 'Prefers luxury accommodations. Interested in cultural experiences.',
  avatar: null,
  tags: ['luxury', 'culture', 'asia'],
  transactions: [{
    id: 101,
    type: 'booking',
    product: 'Japan Cultural Tour',
    date: '2022-03-15',
    amount: 4250,
    status: 'completed'
  }, {
    id: 102,
    type: 'booking',
    product: 'Italy Wine Country',
    date: '2021-09-10',
    amount: 3800,
    status: 'completed'
  }, {
    id: 103,
    type: 'refund',
    product: 'Paris Weekend',
    date: '2021-05-22',
    amount: -1200,
    status: 'processed'
  }],
  browsingHistory: [{
    id: 201,
    page: 'European Cruises',
    date: '2023-05-28',
    duration: '4m 32s'
  }, {
    id: 202,
    page: 'Luxury Bali Packages',
    date: '2023-05-25',
    duration: '7m 15s'
  }, {
    id: 203,
    page: 'Japan Cherry Blossom Tours',
    date: '2023-05-20',
    duration: '12m 03s'
  }],
  preferences: {
    destinations: ['Japan', 'Italy', 'Bali'],
    accommodationType: 'Luxury',
    travelStyle: 'Cultural',
    budget: '$3000-$5000',
    mealPreferences: 'No dietary restrictions',
    specialRequests: 'Prefers window seats on flights'
  }
}, {
  id: 2,
  firstName: 'Jennifer',
  lastName: 'Williams',
  email: 'jwilliams@example.com',
  phone: '+1 (555) 987-6543',
  address: '456 Oak Ave, Seattle, WA',
  status: 'active',
  type: 'new',
  lastContact: '2023-06-10',
  upcomingTrip: 'Caribbean Cruise - August 5, 2023',
  notes: 'First-time customer. Referred by Robert Chen.',
  avatar: null,
  tags: ['cruise', 'beach', 'first-time'],
  transactions: [{
    id: 104,
    type: 'deposit',
    product: 'Caribbean Cruise',
    date: '2023-06-08',
    amount: 500,
    status: 'processed'
  }],
  browsingHistory: [{
    id: 204,
    page: 'Caribbean Cruises',
    date: '2023-06-07',
    duration: '15m 42s'
  }, {
    id: 205,
    page: 'Family Vacation Packages',
    date: '2023-06-05',
    duration: '8m 22s'
  }],
  preferences: {
    destinations: ['Caribbean', 'Mexico'],
    accommodationType: 'Resort',
    travelStyle: 'Relaxation',
    budget: '$2000-$3000',
    mealPreferences: 'Vegetarian options',
    specialRequests: 'Interested in excursions with swimming'
  }
}, {
  id: 3,
  firstName: 'Michael',
  lastName: 'Torres',
  email: 'mtorres@example.com',
  phone: '+1 (555) 456-7890',
  address: '789 Pine St, Chicago, IL',
  status: 'active',
  type: 'repeat',
  lastContact: '2023-05-28',
  upcomingTrip: 'European Tour - September 12, 2023',
  notes: 'Prefers self-guided tours. Interested in history and architecture.',
  avatar: null,
  tags: ['europe', 'history', 'self-guided'],
  transactions: [{
    id: 105,
    type: 'booking',
    product: 'Paris & London Explorer',
    date: '2022-06-20',
    amount: 3200,
    status: 'completed'
  }, {
    id: 106,
    type: 'booking',
    product: 'Spain Highlights',
    date: '2021-11-05',
    amount: 2900,
    status: 'completed'
  }, {
    id: 107,
    type: 'add-on',
    product: 'Private Guide - Louvre',
    date: '2022-06-25',
    amount: 150,
    status: 'completed'
  }],
  browsingHistory: [{
    id: 206,
    page: 'European History Tours',
    date: '2023-05-15',
    duration: '18m 55s'
  }, {
    id: 207,
    page: 'Self-Guided Italy Tours',
    date: '2023-05-10',
    duration: '9m 32s'
  }, {
    id: 208,
    page: 'Architecture Tours Europe',
    date: '2023-05-05',
    duration: '11m 48s'
  }],
  preferences: {
    destinations: ['France', 'Spain', 'Italy', 'UK'],
    accommodationType: 'Boutique Hotels',
    travelStyle: 'Cultural & Historical',
    budget: '$2500-$4000',
    mealPreferences: 'Enjoys local cuisine',
    specialRequests: 'Prefers museums and historical sites'
  }
}, {
  id: 4,
  firstName: 'Sarah',
  lastName: 'Johnson',
  email: 'sjohnson@example.com',
  phone: '+1 (555) 789-0123',
  address: '321 Maple Dr, New York, NY',
  status: 'inactive',
  type: 'repeat',
  lastContact: '2023-01-15',
  upcomingTrip: null,
  notes: 'Has not booked in over 6 months. Send promotional offers.',
  avatar: null,
  tags: ['europe', 'family', 'budget'],
  transactions: [{
    id: 108,
    type: 'booking',
    product: 'Greek Islands Family Package',
    date: '2022-07-10',
    amount: 3600,
    status: 'completed'
  }],
  browsingHistory: [{
    id: 209,
    page: 'Budget Mediterranean Vacations',
    date: '2023-01-10',
    duration: '5m 12s'
  }, {
    id: 210,
    page: 'Family Friendly Europe Tours',
    date: '2023-01-05',
    duration: '7m 45s'
  }],
  preferences: {
    destinations: ['Greece', 'Croatia', 'Spain'],
    accommodationType: 'Family-friendly resorts',
    travelStyle: 'Family vacations',
    budget: '$2000-$3500',
    mealPreferences: 'Kid-friendly options',
    specialRequests: 'Activities for children aged 8-12'
  }
}, {
  id: 5,
  firstName: 'David',
  lastName: 'Miller',
  email: 'dmiller@example.com',
  phone: '+1 (555) 234-5678',
  address: '654 Cedar Ln, Austin, TX',
  status: 'active',
  type: 'repeat',
  lastContact: '2023-06-05',
  upcomingTrip: 'New Zealand Adventure - October 3, 2023',
  notes: 'Adventure traveler. Interested in hiking and outdoor activities.',
  avatar: null,
  tags: ['adventure', 'outdoors', 'hiking'],
  transactions: [{
    id: 109,
    type: 'booking',
    product: 'Peru Hiking Expedition',
    date: '2022-08-15',
    amount: 3900,
    status: 'completed'
  }, {
    id: 110,
    type: 'booking',
    product: 'Costa Rica Adventure',
    date: '2021-12-20',
    amount: 2800,
    status: 'completed'
  }, {
    id: 111,
    type: 'add-on',
    product: 'Zip-lining Experience',
    date: '2021-12-23',
    amount: 120,
    status: 'completed'
  }],
  browsingHistory: [{
    id: 211,
    page: 'New Zealand Trekking Tours',
    date: '2023-06-01',
    duration: '22m 18s'
  }, {
    id: 212,
    page: 'Adventure Sports Packages',
    date: '2023-05-28',
    duration: '9m 05s'
  }, {
    id: 213,
    page: 'Hiking Vacations',
    date: '2023-05-22',
    duration: '14m 32s'
  }],
  preferences: {
    destinations: ['New Zealand', 'Peru', 'Costa Rica', 'Patagonia'],
    accommodationType: 'Eco-lodges',
    travelStyle: 'Adventure & Active',
    budget: '$3000-$5000',
    mealPreferences: 'High-protein, healthy options',
    specialRequests: 'Expert guides for difficult hikes'
  }
}, {
  id: 6,
  firstName: 'Emily',
  lastName: 'Wilson',
  email: 'emily.wilson@example.com',
  phone: '+1 (555) 345-6789',
  address: '987 Elm St, Denver, CO',
  status: 'active',
  type: 'repeat',
  lastContact: '2023-06-08',
  upcomingTrip: 'Thailand Wellness Retreat - August 20, 2023',
  notes: 'Wellness enthusiast. Interested in yoga and meditation retreats.',
  avatar: null,
  tags: ['wellness', 'yoga', 'spa'],
  transactions: [{
    id: 112,
    type: 'booking',
    product: 'Bali Yoga Retreat',
    date: '2022-09-05',
    amount: 2950,
    status: 'completed'
  }, {
    id: 113,
    type: 'booking',
    product: 'Thailand Spa Package',
    date: '2023-06-07',
    amount: 3200,
    status: 'confirmed'
  }],
  browsingHistory: [{
    id: 214,
    page: 'Wellness Retreats Asia',
    date: '2023-06-05',
    duration: '17m 22s'
  }, {
    id: 215,
    page: 'Meditation Vacations',
    date: '2023-06-02',
    duration: '8m 45s'
  }, {
    id: 216,
    page: 'Luxury Spa Resorts',
    date: '2023-05-30',
    duration: '11m 33s'
  }],
  preferences: {
    destinations: ['Thailand', 'Bali', 'India', 'Costa Rica'],
    accommodationType: 'Wellness resorts',
    travelStyle: 'Wellness & Relaxation',
    budget: '$2500-$4000',
    mealPreferences: 'Vegan, organic options',
    specialRequests: 'Daily yoga and meditation sessions'
  }
}];
export const CustomersModule = () => {
  const [customers, setCustomers] = useState(mockCustomers);
  const [filteredCustomers, setFilteredCustomers] = useState(mockCustomers);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  // Apply filters when search term or status filter changes
  useEffect(() => {
    let results = mockCustomers;
    // Apply status filter
    if (statusFilter !== 'all') {
      results = results.filter(customer => customer.status === statusFilter);
    }
    // Apply search term
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      results = results.filter(customer => customer.firstName.toLowerCase().includes(term) || customer.lastName.toLowerCase().includes(term) || customer.email.toLowerCase().includes(term) || customer.upcomingTrip && customer.upcomingTrip.toLowerCase().includes(term) || customer.tags.some(tag => tag.toLowerCase().includes(term)));
    }
    setFilteredCustomers(results);
  }, [searchTerm, statusFilter]);
  const handleCustomerSelect = (customer: any) => {
    setSelectedCustomer(customer);
  };
  const handleAddCustomer = () => {
    setShowAddCustomer(true);
  };
  return <div className="flex flex-col h-full" data-id="element-1977">
      {/* Header */}
      <div className="flex justify-between items-center mb-6" data-id="element-1978">
        <div data-id="element-1979">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-1980">Customers</h1>
          <p className="text-sm text-gray-500" data-id="element-1981">
            Manage your customer database and interactions
          </p>
        </div>
        <button onClick={handleAddCustomer} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-1982">
          <UserPlusIcon className="h-4 w-4 mr-2" data-id="element-1983" />
          Add Customer
        </button>
      </div>

      <div className="flex gap-6 h-[calc(100vh-180px)]" data-id="element-1984">
        {/* Customers list panel */}
        <div className="w-1/3 bg-white rounded-lg shadow-md overflow-hidden flex flex-col" data-id="element-1985">
          {/* Search and filters */}
          <div className="p-4 border-b border-gray-200" data-id="element-1986">
            <div className="relative mb-4" data-id="element-1987">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1988">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-1989" />
              </div>
              <input type="text" placeholder="Search customers..." className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1990" />
            </div>
            <div className="flex space-x-2" data-id="element-1991">
              <button className={`px-3 py-1 rounded-md text-sm ${statusFilter === 'all' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} onClick={() => setStatusFilter('all')} data-id="element-1992">
                All
              </button>
              <button className={`px-3 py-1 rounded-md text-sm ${statusFilter === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} onClick={() => setStatusFilter('active')} data-id="element-1993">
                Active
              </button>
              <button className={`px-3 py-1 rounded-md text-sm ${statusFilter === 'inactive' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'}`} onClick={() => setStatusFilter('inactive')} data-id="element-1994">
                Inactive
              </button>
              <button className="px-3 py-1 rounded-md text-sm bg-gray-100 text-gray-800 flex items-center" data-id="element-1995">
                <FilterIcon className="h-3 w-3 mr-1" data-id="element-1996" />
                More
              </button>
            </div>
          </div>
          {/* Customer list */}
          <CustomersList customers={filteredCustomers} selectedCustomerId={selectedCustomer?.id} onSelectCustomer={handleCustomerSelect} data-id="element-1997" />
        </div>

        {/* Customer details panel */}
        <div className="w-2/3 bg-white rounded-lg shadow-md overflow-hidden" data-id="element-1998">
          {selectedCustomer ? <CustomerProfile customer={selectedCustomer} data-id="element-1999" /> : <div className="flex flex-col items-center justify-center h-full p-6 text-center" data-id="element-2000">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-2001">
                <UsersIcon className="h-8 w-8 text-gray-400" data-id="element-2002" />
              </div>
              <h2 className="text-xl font-medium text-gray-800 mb-2" data-id="element-2003">
                No Customer Selected
              </h2>
              <p className="text-gray-600 mb-6 max-w-md" data-id="element-2004">
                Select a customer from the list to view their profile,
                transaction history, and preferences, or add a new customer to
                your database.
              </p>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" onClick={handleAddCustomer} data-id="element-2005">
                Add New Customer
              </button>
            </div>}
        </div>
      </div>
    </div>;
};